import { Component, Input, OnInit } from '@angular/core';
import { ListPageColumnComponent } from 'design-system';
import { ProductStock } from '../../../interfaces/product.model';

@Component({
  selector: 'prd-availability-chip',
  imports: [],
  templateUrl: './availability-chip.html',
  styleUrl: './availability-chip.scss',
})
export class AvailabilityChip extends ListPageColumnComponent implements OnInit {
  @Input() stock: ProductStock | null | undefined;

  get indicatorClass(): string {
    return `availability-indicator--${this.stock?.availability?.toLowerCase() ?? 'unknown'}`;
  }

  get iconClass(): string {
    switch (this.stock?.availability) {
      case 'HIGH':
        return 'fa-solid fa-circle-check';
      case 'LOW':
        return 'fa-solid fa-circle-exclamation';
      case 'NONE':
        return 'fa-solid fa-circle-exclamation';
      default:
        return 'fa-solid fa-circle-question';
    }
  }

  get label(): string {
    let availabilityLabel: string;

    switch (this.stock?.availability) {
      case 'HIGH':
        availabilityLabel = 'Disponibilità alta';
        break;
      case 'LOW':
        availabilityLabel = 'Disponibilità bassa';
        break;
      case 'NONE':
        availabilityLabel = 'Non disponibile';
        break;
      default:
        availabilityLabel = 'Disponibilità non ricevuta';
    }

    return this.hasQuantity
      ? `${availabilityLabel}, quantità ${this.stock?.quantity}`
      : availabilityLabel;
  }

  get hasQuantity(): boolean {
    return this.stock?.quantity !== null
      && this.stock?.quantity !== undefined
      && this.stock.quantity !== 0;
  }

  ngOnInit() {
    if (this.itemData && this.infoColumn) {
      this.stock = this.itemData[this.infoColumn.columnNameDef];
    }
  }
}
